<template>
  <div
    class="next-available-time-button-wrapper"
    v-if="showNextAvailableTimeButton || forceShow"
  ></div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  props: {
    forceShow: {
      default: false,
    },
  },
  computed: {
    ...mapGetters(["showNextAvailableTimeButton"]),
  },
  methods: {
    ...mapActions(["getAvailableTimes"]),
  },
};
</script>
